import { createApp } from "vue";
import PaginaProjeto from "./PaginaProject.vue";

const app = createApp({
  components: {
    "pagina-projeto-component": PaginaProjeto,
  },
}).mount("#container-projeto");
